import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface SignalREvent {
  type: string;
  payload: any;
}

interface SignalRState {
  events: SignalREvent[];
  redactionEvents: SignalREvent[];
  lastEvent?: SignalREvent | null;
}

const initialState: SignalRState = {
  events: [],
  redactionEvents: [],
  lastEvent: null,
};

const signalrSlice = createSlice({
  name: 'signalr',
  initialState,
  reducers: {
    receiveSignalREvent: (state, action: PayloadAction<SignalREvent>) => {
      state.events.push(action.payload);
      state.lastEvent = action.payload;
    },
    clearSignalREvents: (state) => {
      state.events = [];
      state.lastEvent = null;
      state.redactionEvents = [];
    },
    setRedactionEvents: (state, action: PayloadAction<SignalREvent>) => {
      state.redactionEvents.push(action.payload);
    },
    clearRedactionEvents: (state) => {
      state.redactionEvents = [];
    },
  },
});

export const {
  receiveSignalREvent,
  clearSignalREvents,
  setRedactionEvents,
  clearRedactionEvents,
} = signalrSlice.actions;
export default signalrSlice.reducer;
